module.exports = __webpack_public_path__ + "/images/g-bottom.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/g-bottom.png
// module id = 220
// module chunks = 0